import { atom } from 'jotai';
import { MeetingsToolsParams, MeetingsToolsParamsType } from './types';

export * from './types';

export const MeetingsToolsParamsAtom = atom<MeetingsToolsParams>({
    type: MeetingsToolsParamsType.Empty,
});
